const carouselItems = [
  {
    tag: '独家爆料',
    title: '顶流男星深夜密会神秘女子，酒店同框照曝光引热议',
    summary: '据知情人士透露，该男星与神秘女子在某五星级酒店共度一整晚，次日清晨才先后离开。照片中两人举止亲密，引发粉丝和网友广泛讨论。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20composition%20with%20warm%20red%20and%20black%20tones%2C%20geometric%20shapes%20representing%20secrets%20and%20scandal%2C%20dramatic%20noir%20atmosphere%2C%20editorial%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=c01-51-003&orientation=landscape',
    time: '2小时前',
    views: '128.6万',
  },
  {
    tag: '综艺内幕',
    title: '某热门综艺录制现场突发意外，两位嘉宾当场翻脸离场',
    summary: '据悉涉事嘉宾因游戏环节产生严重分歧，争执升级后双双拒绝继续录制。节目组紧急叫停，目前正在协调调解，本期节目能否正常播出存疑。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20collision%20concept%20with%20warm%20amber%20and%20crimson%20fragments%2C%20split%20composition%20representing%20conflict%2C%20editorial%20artistic%20render%2C%20no%20text%20no%20people%2C%20cinematic%20lighting&width=800&height=500&seq=c02-51-004&orientation=landscape',
    time: '5小时前',
    views: '96.3万',
  },
  {
    tag: '网红翻车',
    title: '千万粉网红直播带货翻车？被曝产品质量严重不符宣传',
    summary: '多名消费者联合发声，控诉该网红推荐的美妆产品使用后出现过敏反应，与直播中宣传的"温和不刺激"严重不符。品牌方暂未回应。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20shattered%20glass%20effect%20in%20warm%20red%20and%20gold%20tones%2C%20broken%20geometric%20shapes%2C%20dramatic%20editorial%20composition%2C%20no%20text%20no%20people%2C%20modern%20artistic%20style&width=800&height=500&seq=c03-51-005&orientation=landscape',
    time: '8小时前',
    views: '203.1万',
  },
  {
    tag: '娱乐圈大瓜',
    title: '知名导演被曝潜规则多名新人，业内人士实名举报',
    summary: '一封实名举报信在社交平台疯传，指控某知名导演利用选角之便对多名新人演员进行不当行为。目前相关部门已介入调查，涉事导演暂未回应。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20crimson%20abstract%20geometric%20composition%2C%20layered%20shadows%20representing%20hidden%20truth%2C%20dramatic%20editorial%20art%2C%20no%20text%20no%20people%2C%20intense%20cinematic%20atmosphere&width=800&height=500&seq=c04-51-006&orientation=landscape',
    time: '12小时前',
    views: '356.7万',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">焦点爆料</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {item.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}